<template>
  <div>
    <v-dialog v-model="isOpen" max-width="870">
      <v-card class="user-welcome pb-8">
        <v-card-title primary-title>
          <v-spacer></v-spacer>
          <v-btn outlined small fab @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="text-center title-container">
          <h2 class="user-welcome__title">{{ $t('howToWork') }}</h2>
        </div>
        <div class="user-welcome__inner">
          <div class="text-center">
            <img class="user-welcome__image" src="@/assets/support.png" />
          </div>
          <div>
            <v-row class="user-welcome__inner--row mt-8" justify="center">
              <v-col cols="4" class="user-welcome__inner--column">
                <v-btn
                  color="primary"
                  :loading="isLoading"
                  large
                  depressed
                  rounded
                  block
                  @click="openSupport"
                >{{ $t('openSupport') }}</v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['viewer'],
  data: () => ({
    isOpen: false,
    isLoading: false,
    snackbarShown: false,
    lesson: '',
  }),
  computed: {
    copiedLink() {
      return `${window.location.host}/lesson/${this.lesson}`;
    },
  },
  methods: {
    openDialog(lesson) {
      this.lesson = lesson;
      this.isOpen = true;
      this.$store.dispatch('setWelcomeDialog', true);
    },
    openSupport() {
      const win = window.open('https://podpora.ucime.se/', '_blank');
      win.focus();
    },
    hideSnackbar() {
      this.snackbarShown = false;
    },
    closeDialog() {
      this.isOpen = false;
      this.$store.dispatch('setWelcomeDialog', false);
    },

    submitForm() {},
  },
};
</script>

<style lang="scss">
.user-welcome {
  &__title {
    padding-bottom: 15px;
  }
  &__image {
    width: 100%;
    height: auto;
  }
  &__inner {
    max-width: 650px;
    margin: 0 auto;

    padding-top: 2vh;
    padding-bottom: 2vh;
    @media (max-width: 1024px) {
      &--row {
        flex-direction: column !important;
      }
      &--column {
        width: 100% !important;
        max-width: 100%;
      }
    }
  }
}
</style>
